import api from '@shared/services/api';

export const levelOfStructureService = {
    getAllLevels: async (companyId) => {
        try {
            const response = await api.get(`/org-unit-levels/company/${companyId}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching all levels:', error);
            throw error;
        }
    },

    getLevels: async (companyId, searchParams = {}) => {
        try {
            const params = new URLSearchParams();
            if (searchParams.shortDescription) {
                params.append('shortDescription', String(searchParams.shortDescription));
            }
            if (searchParams.longDescription) {
                params.append('longDescription', String(searchParams.longDescription));
            }
            const queryString = params.toString();

            if (queryString) {
                const response = await api.get(`/org-unit-levels?${queryString}`);
                return response.data;
            }

            if (companyId) {
                const response = await api.get(`/org-unit-levels/company/${companyId}`);
                return response.data;
            }

            const response = await api.get('/org-unit-levels');
            return response.data;
        } catch (error) {
            console.error('Error fetching levels:', error);
            throw error;
        }
    },

    createLevel: async (levelData) => {
        try {
            const formattedData = {
                empBranchId: parseInt(levelData.company),
                planLevel: parseInt(levelData.level),
                code: levelData.code,
                shortDescription: levelData.abbreviation,
                longDescription: levelData.title,
                fromDate: levelData.fromDate,
                toDate: levelData.toDate
            };

            const response = await api.post('/org-unit-levels', formattedData);
            return response.data;
        } catch (error) {
            console.error('Error creating level:', error);
            throw error;
        }
    },

    updateLevel: async (id, levelData) => {
        try {
            const formattedData = {
                empBranchId: parseInt(levelData.company),
                planLevel: parseInt(levelData.level),
                code: levelData.code,
                shortDescription: levelData.abbreviation,
                longDescription: levelData.title,
                fromDate: levelData.fromDate,
                toDate: levelData.toDate
            };

            const response = await api.put(`/org-unit-levels/${id}`, formattedData);
            return response.data;
        } catch (error) {
            console.error('Error updating level:', error);
            throw error;
        }
    },

    deleteLevel: async (id) => {
        try {
            const response = await api.delete(`/org-unit-levels/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting level:', error);
            throw error;
        }
    },

    getOrgUnitsByLevel: async (levelId) => {
        try {
            if (!levelId) {
                return [];
            }
            const response = await api.get(`/org-unit/${levelId}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching org units by level:', error);
            throw error;
        }
    },

    getPositionsByStructuralGroup: async (structuralGroupId) => {
        try {
            if (!structuralGroupId) {
                return [];
            }
            const response = await api.get(`/hr-positions/${structuralGroupId}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching positions by structural group:', error);
            throw error;
        }
    },

    getOrgUnitById: async (companyId, searchParams = {}) => {
        try {
            if (!companyId) {
                return [];
            }

            const params = {
                pLang: 'en_US',
                companyId: companyId,
                language: 'en_US'
            };

            if (searchParams && typeof searchParams === 'object') {
                Object.entries(searchParams).forEach(([key, value]) => {
                    if (value !== null && value !== undefined) {
                        // Handle string values with trim
                        if (typeof value === 'string' && value.trim()) {
                            params[key] = value.trim();
                        }
                        // Handle non-string values (numbers, booleans, etc.)
                        else if (typeof value !== 'string') {
                            params[key] = value;
                        }
                    }
                });
            }

            const response = await api.get('/org-unit/children', { params });
            return response.data;
        } catch (error) {
            console.error('❌ Error fetching org unit children:', error);
            console.error('❌ Error response:', error.response?.data);
            console.error('❌ Error status:', error.response?.status);
            throw error;
        }
    },

    getTranslation: async (orgUnitLevelsId) => {
        try {
            const response = await api.get(`/org-unit-levels/translation/${orgUnitLevelsId}`);
            return response.data;
        } catch (error) {
            console.error('Error getting translation:', error);
            throw error;
        }
    },

    saveTranslation: async (translationData) => {
        try {
            const response = await api.post('/org-unit-levels/translate', translationData);
            return response.data;
        } catch (error) {
            console.error('Error saving translation:', error);
            throw error;
        }
    },
    getPositionsForContract: async (orgUnitId) => {
        try {
            if (!orgUnitId) {
                return [];
            }
            const response = await api.get(`/hr-positions/list-contract/${orgUnitId}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching positions for contract:', error);
            throw error;
        }
    },

    getPositionByIdForContract: async (positionId) => {
        try {
            if (!positionId) {
                return null;
            }
            const response = await api.get(`/hr-positions/contract/${positionId}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching position by id for contract:', error);
            throw error;
        }
    }
};

